export enum ProductOfferingId {
  GenericLinesProduct = 'clb5i45q90003ukv54zyd7wou',
  SwimClub = 'clxo6f3xb00050cmoaapk33r6',
  SpecialEvent = 'cm6pxdblu00009jv5c7ev0ul4',
  AmateurSports = 'cljza1h7w0000jov5alt29j7n',
  NonprofitAndSocialServices = 'cloonk7sg00008iv7fe8f3kb4',
  HomeOwnersAssociation = 'cmg9t0iju00014z5u31woesn0',
  CondoOwnersAssociation = 'cmga4g2rc0000l6sfgzoubwln',
}

export const InsuranceProductIds = {
  SwimClub: 'clxo6f3xb00040cmo7jxth3fh',
  SpecialEvents: 'cm6pxcus7000079v5huwggpl1',
  HomeOwnersAssociation: 'cmg9t0iju00004z5u12i246jr',
  CondoOwnersAssociation: 'cmga7fhxy00011ssf5hhd205e',
};
